import {DrawerProps} from '@mantine/core';
import {FormDrawer} from './FormDrawer';
import {useCreateUserMutation} from '../hooks/useUsersQuery';
import {User} from '../types';

// A new person starts from an empty record. The console's copy called useUser()
// here, which loaded the whole list just to get `undefined`.
export const AddFormDrawer = (props: DrawerProps) => {
    const createUserMutation = useCreateUserMutation();

    return (
        <FormDrawer
            record={{} as User}
            handleSubmit={(values) => createUserMutation.mutateAsync(values)}
            {...props}
        />
    );
};
